<template>
    <div class="target-page-header">
        <div class="target-page-header__title-group">
            <h3 class="target-page-header__title">{{ title }}</h3>
            <p v-if="subtitle" class="target-page-header__subtitle">{{ subtitle }}</p>
        </div>
        <div v-if="$slots.actions" class="target-page-header__actions">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "TargetPageHeader",
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: "",
        },
    },
};
</script>

<style scoped>
.target-page-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
}

.target-page-header__title-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.target-page-header__title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.target-page-header__subtitle {
    font-size: 13px;
    color: #6b7280;
    margin: 0;
}

.target-page-header__actions {
    display: flex;
    gap: 8px;
    align-items: center;
}
</style>
